import { useQuery } from "@apollo/client";

import { GET_GITHUB_INTEGRATION } from "./gql";

const useGetGitHubIntegration = () => {
  const { data, loading, error } = useQuery(GET_GITHUB_INTEGRATION, {
    fetchPolicy: "no-cache",
  });

  return {
    integration: data?.githubIntegration,
    isPageLoading: loading && !data?.githubIntegration,
    error,
  };
};

export default useGetGitHubIntegration;
